import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const base =
  "group inline-flex items-center justify-center gap-2 rounded-sm px-7 py-3.5 text-sm font-semibold tracking-wide transition-[background-color,color,border-color,box-shadow,transform] duration-300 hover:-translate-y-0.5 focus:outline-none focus:ring-2 focus:ring-brand focus:ring-offset-2";

const variants = {
  primary: "bg-brand text-white hover:bg-brand-dark hover:shadow-lg",
  dark: "bg-gray-950 text-white hover:bg-gray-800 hover:shadow-lg",
  outline: "border border-gray-900 text-gray-950 hover:bg-gray-950 hover:text-white",
  ghost: "text-gray-950 underline-offset-4 hover:underline px-0 py-0",
};

export function ButtonLink({ to, children, variant = "primary", className = "", testId, arrow = true, ...rest }) {
  return (
    <Link to={to} data-testid={testId} className={`${base} ${variants[variant]} ${className}`} {...rest}>
      {children}
      {arrow && (
        <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" aria-hidden="true" />
      )}
    </Link>
  );
}

export function ButtonButton({ children, variant = "primary", className = "", testId, arrow = true, ...rest }) {
  return (
    <button data-testid={testId} className={`${base} ${variants[variant]} ${className}`} {...rest}>
      {children}
      {arrow && (
        <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" aria-hidden="true" />
      )}
    </button>
  );
}
